import axios from 'axios'
import { Toast, Dialog } from 'vant'
import store from '@/store'
import { getToken, getAccountId } from '@/utils/auth'
import { GetQueryString } from '@/utils/wechat'

import qs from 'qs'
// create an axios instance
const service = axios.create({
  //baseURL: process.env.NODE_ENV === 'development' ? '/' : process.env.VUE_APP_BASE_API,
  baseURL: window.baseUrlConfig.VUE_APP_BASE_API,
  timeout: 60000 // request timeout
})
// request interceptor
service.interceptors.request.use(
  config => {
    // Do something before request is sent
    // if (store.getters.token) {
    // 让每个请求携带token等 请根据实际情况自行修改
    const data = qs.parse(config.data)
    var token = getToken()
    var accountId = getAccountId()
    config.headers['token'] = token
    config.headers['appid'] = 'OLsemPv63fvohMGu'
    config.headers['Accept-Language'] = store.getters.language// 语言模式
    config.headers['wechatappid'] = GetQueryString('state') || 'wx6054546f7e4e24b6'
    if (config.baseURL === 'other') {
      config.baseURL = window.baseUrlConfig.VUE_APP_OTHER_API
      //config.baseURL = process.env.VUE_APP_OTHER_API
    }
    if (config.method === 'post' || config.method === 'PUT') {
      if (!Array.isArray(config.data) && typeof config.data !== 'string') {
        config.data = {
          accountId: accountId || 1,
          ...data
        }
      }
    } else if (config.method === 'get' || config.method === 'patch' || config.method === 'delete' || config.method === 'put') {
      config.params = {
        accountId: accountId || 1,
        ...config.params
      }
    }

    return config
  },
  error => {
    // Do something with request error
    Promise.reject(error)
  }
)

// response interceptor
service.interceptors.response.use(
  response => {
    if (response.status === 401) {
      localStorage.clear()
      sessionStorage.clear()
      location.reload()
      return Promise.reject('未登录')
    }

    const res = response.data
    if (res.code === -3) {
      Dialog.alert({
        message: '弹窗内容'
      }).then(_ => {})
      return Promise.reject('error')
    } else if (res.code !== 0) {
      // 非5xx的错误属于业务错误，留给具体页面处理
      Toast({
        message: res.msg,
        duration: 1500
      })
      return Promise.reject(response)
    } else {
      return response
    }
  }, error => {
    Toast({
      message: '连接超时',
      duration: 1500
    })
    return Promise.reject(error)
  })

export default service
